import React, { useEffect, useState } from 'react';
import { Layout, Card, Select, Button, message } from 'antd';
import Sidebar from 'components/layout/Sidebar';
import Header from 'components/layout/Header';
import AllFilesTable from 'components/table/AllFilesTable';
import GoogleDriveApi from '../apiServices/GoogleDriveApi';
import axios from 'axios';
import apiEndPoints, { headers } from 'configs/endPoints';
import useWindowDimensions from 'data/useWindowDimensions';
import constants from 'data/constants';
import UploadOutlined from '@ant-design/icons/UploadOutlined';
import Loader from 'components/layout/Loader';
import FileUploadModal from './FileUploadModal';

const Home = () => {
	const { Content } = Layout;
	const [ data, setData ] = useState([]);
	const [ ownerId, setOwnerId ] = useState([]);
	const [ fileUploadModalVisiblity, setFileUploadModalVisiblity ] = useState(false);
	const [ isLoading, setIsLoading ] = useState(false);
	const { Option } = Select;
	const { width } = useWindowDimensions();

	useEffect(() => {
		axios
			.get(`${apiEndPoints.getAllFileFromContentLib}`, headers('accessToken'))
			.then((response) => {
				//	console.log(response.data.data);
				setData(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);

	useEffect(() => {
		axios
			.get(`${apiEndPoints.getAllDistinctOwnerIdFromContentLib}`, headers('accessToken'))
			.then((response) => {
				//console.log('setOwnerId', response.data.data);
				setOwnerId(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);

	// Google Drive Code starts here

	//The Browser API key obtained from the Google API Console.
	// Replace with your own Browser API key, or your own key.
	var developerKey = 'AIzaSyAZKKE9Aqo0BkWXL9Lh14hYd1f1ciiAPZs';

	// The Client ID obtained from the Google API Console. Replace with your own Client ID.
	var clientId = '221719329929-vt17b8rsoq1ppepp0sc6cnij4294srbf.apps.googleusercontent.com';

	// Replace with your own project number from console.developers.google.com.
	// See "Project number" under "IAM & Admin" > "Settings"
	var appId = '221719329929';

	// Scope to use to access user's Drive items.
	const scope = [ 'https://www.googleapis.com/auth/drive.file' ];

	let pickerApiLoaded = false;
	var oauthToken;

	const showPickerDialog = () => {
		loadPicker();
	};
	const showFileUploadModal = () => {
		setFileUploadModalVisiblity(true);
	};

	// Use the Google API Loader script to load the google.picker script.
	let loadPicker = () => {
		window.gapi.load('auth', { callback: onAuthApiLoad });
		window.gapi.load('picker', { callback: onPickerApiLoad });
	};

	const onAuthApiLoad = () => {
		window.gapi.auth.authorize(
			{
				client_id: clientId,
				scope: scope,
				immediate: false
			},
			handleAuthResult
		);
	};

	let onPickerApiLoad = () => {
		pickerApiLoaded = true;
		createPicker();
	};

	const handleAuthResult = (authResult) => {
		if (authResult && !authResult.error) {
			oauthToken = authResult.access_token;
			createPicker();
		}
	};

	// Create and render a Picker object for searching images.
	const createPicker = () => {
		if (pickerApiLoaded && oauthToken) {
			const view = new window.google.picker.View(window.google.picker.ViewId.FOLDERS);
			view.setMimeTypes(
				'image/png,image/jpeg,image/jpg,application/pdf,application/zip,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
			);
			const picker = new window.google.picker.PickerBuilder()
				//.enableFeature(google.picker.Feature.NAV_HIDDEN)
				.enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
				.setAppId(appId)
				.setOAuthToken(oauthToken)
				.addView(view)
				.addView(window.google.picker.ViewId.VIDEO_SEARCH)
				.addView(window.google.picker.ViewId.DOCUMENTS)
				.addView(window.google.picker.ViewId.PDFS)
				.addView(window.google.picker.ViewId.SPREADSHEETS)
				.addView(window.google.picker.ViewId.PRESENTATIONS)
				.addView(window.google.picker.ViewId.YOUTUBE)
				.addView(window.google.picker.ViewId.DOCS_VIDEOS)
				.addView(new window.google.picker.DocsUploadView())
				.setDeveloperKey(developerKey)
				.setCallback(pickerCallback)
				.build();
			picker.setVisible(true);
		}
	};

	// A simple callback implementation.
	const pickerCallback = (data) => {
		if (data.action === window.google.picker.Action.PICKED) {
			const fileId = data.docs;
			let fileIds = [];
			for (let i = 0; i < fileId.length; i++) {
				const element = fileId[i].id;
				fileIds.push(element);
				setIsLoading(true);
				axios
					.get(
						`${apiEndPoints.downloadGoogleDriveFileM}?userName=RivetAdmin&fileIds=${fileIds}`
						//headers('accessToken')
					)
					.then((response) => {
						setIsLoading(false);
						console.log('drte', response.data);
						message.success(response.data.description);
					})
					.catch((error) => {
						console.log(error);
					});
				//alert('The user selected: ' + element);
			}
			// listFiles(fileId);
			console.log('file', data.docs.length);
			console.log('dataFileId', fileIds);
			//alert('The user selected: ' + fileId);
		}
	};

	// Google Drive Code ends here

	return (
		<Layout style={{ minHeight: '100vh' }}>
			<Sidebar selectedKey="home" />
			<Layout style={{ minHeight: '80vh', marginLeft: 200 }}>
				<Header title="Home Page" />
				<Content style={{ padding: '10px 20px', marginTop: 64 }}>
					<Card className="card-full">
						<div
							style={{
								justifyContent: 'flex-end',
								display: 'flex',
								width: '100%'
							}}
						>
							<Select placeholder="Select OwnerId" allowClear>
								{ownerId &&
									ownerId.map((item) => (
										<Option key={item} value={item}>
											{item}
										</Option>
									))}
							</Select>
							<Button
								//	onClick={handleCreateAccountClick}
								onClick={showFileUploadModal}
								type="primary"
								style={{ width: width < constants.PHONE_WIDTH ? '100%' : 'auto', marginLeft: 20 }}
							>
								<UploadOutlined /> Bulk Upload
							</Button>
							<Button
								//	onClick={handleCreateAccountClick}
								onClick={showPickerDialog}
								type="primary"
								style={{ width: width < constants.PHONE_WIDTH ? '100%' : 'auto', marginLeft: 20 }}
							>
								<UploadOutlined /> Google Drive
							</Button>
							<Button
								//	onClick={handleCreateAccountClick}
								//onClick={showPickerDialog}
								type="primary"
								style={{ width: width < constants.PHONE_WIDTH ? '100%' : 'auto', marginLeft: 20 }}
							>
								<UploadOutlined /> One Drive
							</Button>
						</div>
					</Card>
					<Card className="card-full" style={{ marginTop: 20, overflowX: 'visible' }}>
						<div>
							<AllFilesTable data={data} />
						</div>
					</Card>
					<Loader
						isLoading={isLoading}
						tip="Currently downloading file from cloud to content library please wait..."
					/>
					<FileUploadModal
						visible={fileUploadModalVisiblity}
						setVisible={setFileUploadModalVisiblity}
						//data={data}
					/>
				</Content>
			</Layout>
		</Layout>
	);
};

export default Home;
